import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage, useFormikContext } from "formik";
import InputLayout from "../../../atoms/InputLayout";
import * as Yup from "yup";
import CountryCodeDropdown from "../../../molecules/Dropdown/CountryCodeDropdown";
import Error from "../../../atoms/Error";
import { postData, patchData, getData } from "../../../../services";
import { useCookies } from "react-cookie";
import toast from "react-hot-toast";
import {
  confimationStyles,
  errorStyles,
} from "../../../../assets/styles/toast";
import SelectDropdown from "../../../molecules/Dropdown";
import { getEmployeeList } from "../../../../services/basicGets";

const UserForm = ({
  onFormDirty,
  initialData,
  onClose,
  refetchData,
  teamsList,
  // employeeList,
  departmentList,
  rolesList,
  isAdmin,
}) => {
  const [cookies] = useCookies(["e_t"]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [employeeList, setEmployeeList] = useState([]);


  useEffect(() => {
        (async () => {
          const resEmployee = await getEmployeeList({
            params: { ...(!isAdmin && { employee_id: cookies.euid }),status: JSON.stringify(["Active","Inactive"]) },
            token: cookies.e_t,
          });
  
           setEmployeeList(resEmployee?.employeeResponseValueLabel);
          //  setFilteredAssignedTo(resEmployee?.employeeResponseValueLabel);
      })();
    }, []);
  // Initial form values
  const initialValues = {
    name: initialData?.name || "",
    email: initialData?.email || "",
    designation: initialData?.designation || "",
    country_code: initialData?.country_code || "+91",
    mobile: initialData?.mobile || "",
    assigned_teams: initialData?.assigned_teams || [],
    role_id: initialData?.role_id || "",
    working_hours: initialData?.working_hours || null,
    reporting_manager: initialData?.reporting_manager || null,
    emp_id: initialData?.emp_id || "",
    department_id: initialData?.department_id || null,
    status: initialData?.status || "",
  };

  // Validation schema
  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
    email: Yup.string()
    .matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      "Invalid email format"
    )
    .required("Email is required"),
    designation: Yup.string(),
    country_code: Yup.string().required("Country Code is required"),
    role_id: Yup.string().required("Role is required"),
    
  });

  // Create Employee
  const handleSubmit = async (values, { resetForm }) => {
    setIsSubmitting(true);
    try {
      const res = await postData({
        endpoint: "Auth/createEmployee",
        data: {
          ...values,
          working_hours: values.working_hours
            ? Number(values.working_hours)
            : null,
        },
        token: cookies.e_t,
      });

      if (res) {
        toast.success("Employee Created Successfully", {
          style: confimationStyles,
          duration: 1000,
        });
        resetForm();
        onClose();
        refetchData();
      }
    } catch (err) {
      toast.error("Error Creating Employee", { style: errorStyles });
    } finally {
      setIsSubmitting(false);
    }
  };

  // Edit Employee
  const handleEdit = async (values) => {
    setIsSubmitting(true);
    try {
      const res = await patchData({
        endpoint: "Employee/EditEmployeeById",
        token: cookies.e_t,
        data: values,
        params: { id: initialData?.id },
      });

      if (res.status) {
        toast.success("User Updated Successfully", {
          style: confimationStyles,
          duration: 1000,
        });
        refetchData();
      } else {
        toast.error(res.message, { style: confimationStyles, duration: 1000 });
      }

      onClose();
    } catch (error) {
      toast.error("Error Updating User", { style: errorStyles });
    } finally {
      setIsSubmitting(false);
    }
  };

  const statusOptions = [
    { value: "Active", label: "Active" },
    { value: "Inactive", label: "Inactive" },
    { value: "Left", label: "Left" },
  ];

  const checkEmail = async (newVal) => {
    const response = await getData({
      endpoint: "Auth/checkEmail",
      params: { email: newVal },
      token: cookies.e_t,
    });
    if (response.status) {
      setEmailError(null);
    } else {
      setEmailError("This email is already registered.");
    }
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values, { resetForm }) => {
        if (initialData) {
          handleEdit(values);
        } else {
          handleSubmit(values, { resetForm });
        }
        onFormDirty(false);
      }}
      validateOnBlur={false}
      validateOnChange={false}
      enableReinitialize={true}
    >
      {({
        values,
        setFieldValue,
        touched,
        errors,
        setFieldTouched,
        handleBlur,
      }) => (
        <>
          <FormObserver onFormDirty={onFormDirty} />
          <Form className="mt-3">
            {/* Name & Employee ID */}
            <div className="row gx-4">
              <InputLayout>
                <label className="required-field">Employee Name</label>
                <Field name="name" />
                <Error error={errors.name} />
              </InputLayout>

              <InputLayout>
                <label>Emp. ID</label>
                <Field name="emp_id" />
              </InputLayout>
            </div>

            {/* Email & Phone Number */}
            <div className="row gx-4 mt-3">
              <InputLayout>
                <label className="required-field">Email</label>
                <Field
                  name="email"
                  type="email"
                  onBlur={(e) => {
                    if (initialValues.email !== values.email) {
                      checkEmail(values.email);
                    }
                    handleBlur(e);
                  }}
                />
                <Error error={errors.email || emailError} />
              </InputLayout>

              <InputLayout>
                <label>Phone Number</label>
                <div className="d-flex gap-3">
                  <CountryCodeDropdown
                    selectedValue={values.country_code}
                    onChange={(code) => setFieldValue("country_code", code)}
                    isError={touched.country_code && !!errors.country_code}
                  />
                  <Field
                    type="text"
                    name="mobile"
                    className={`w-100 ${errors.mobile ? "error-input" : ""}`}
                    onChange={(e) => {
                      let numericInput = e.target.value.replace(/[^0-9]/g, "");
                      setFieldValue("mobile", numericInput);
                    }}
                  />
                </div>
                <Error error={errors.mobile} />
              </InputLayout>
            </div>

            {/* Designation & Reporting Manager */}
            <div className="row gx-4 mt-3">
              <InputLayout>
                <label >Designation</label>
                <Field name="designation" />
                <Error error={errors.designation} />
              </InputLayout>

              <InputLayout>
                <label>Report To</label>
                <SelectDropdown
                  isClearable={true}
                  onClear={()=>setFieldValue("reporting_manager",null)}
                  data={employeeList}
                  onChange={(option) =>
                    setFieldValue("reporting_manager", option)
                  }
                  selectedValue={values.reporting_manager}
                />
              </InputLayout>
            </div>

            {/* Working Hours & Department */}
            <div className="row gx-4 mt-3">
              <InputLayout>
                <label>Working Hours</label>
                <Field name="working_hours" type="number" />
                <Error error={errors.working_hours} />
              </InputLayout>

              <InputLayout>
                <label>Department</label>
                <SelectDropdown
                  isClearable={true}
                  onClear={()=>setFieldValue("department_id",null)}
                  data={departmentList}
                  onChange={(option) => setFieldValue("department_id", option)}
                  selectedValue={values.department_id}
                />
              </InputLayout>
            </div>

            {/* Role */}
            <div className="row gx-4 mt-3">
              <InputLayout>
                <label className="required-field">Role</label>
                <SelectDropdown
                  isClearable={true}
                  onClear={()=>setFieldValue("role_id",null)}
                  data={
                    isAdmin
                      ? rolesList
                      : rolesList.filter((role) => role.label !== "Admin")
                  }
                  onChange={(option) => setFieldValue("role_id", option)}
                  selectedValue={values.role_id}
                />
                <Error error={errors.role_id} />
              </InputLayout>

              <InputLayout>
                <label className="">Assigned Teams</label>
                <SelectDropdown
                  data={teamsList}
                  multiSelect={true}
                  onChange={(option) => setFieldValue("assigned_teams", option)}
                  selectedValue={values.assigned_teams}
                  onClear={() => setFieldValue("assigned_teams", [])}
                  sError={touched.assigned_teams && errors.assigned_teams}
                />
              </InputLayout>
            </div>


            {initialData?.status && (
              <div className=" mt-3 col-6">
                <InputLayout>
                  <label>Status</label>
                  <SelectDropdown
                    isClearable={false}
                    data={statusOptions}
                    onChange={(option) => setFieldValue("status", option)}
                    selectedValue={values.status}
                  />
                  <Error error={errors.status} />
                </InputLayout>
              </div>
            )}

            {/* Buttons */}
            <div className="drawer-footer mt-4">
              <button
                type="button"
                className="btn btn-outline-primary"
                onClick={onClose}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={isSubmitting}
              >
                {initialData ? "Update" : "Save"}
              </button>
            </div>
          </Form>
        </>
      )}
    </Formik>
  );
};

const FormObserver = ({ onFormDirty }) => {
  const { dirty } = useFormikContext();
  useEffect(() => onFormDirty(dirty), [dirty, onFormDirty]);
  return null;
};

export default UserForm;
